import React from 'react';
import { Text, View } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';
import { useT } from '../i18n/useT';

export default function MissionPrerequisites({ text, requiresP1 }: { text?: string; requiresP1?: boolean }) {
  const { isDarkTheme } = useTheme();
  const c = getThemeColors(isDarkTheme);
  const t = useT();
  const lines = (text || '').split('\n').map(x => x.trim()).filter(Boolean);
  if (!lines.length && !requiresP1) return null;
  return <View accessibilityRole="summary" style={{ padding: 16, marginVertical: 12,
    borderWidth: 2, borderColor: c.warning, borderRadius: 12, backgroundColor: c.warning + '18' }}>
    <Text style={{ color: c.textPrimary, fontSize: 17, fontWeight: '700', marginBottom: 8 }}>
      {t('prerequisites.title')}
    </Text>
    {lines.map((line, i) => <Text key={i} style={{ color: c.textPrimary, lineHeight: 22, marginBottom: 6 }}>• {line}</Text>)}
    {requiresP1 && <>
      <Text style={{ color: c.warning, fontWeight: '700', marginTop: 8 }}>{t('prerequisites.p1Unknown')}</Text>
      <Text style={{ color: c.textSecondary, lineHeight: 20, marginTop: 4 }}>{t('prerequisites.p1Help')}</Text>
    </>}
  </View>;
}
